export const getXMLFieldsArray = (xmlBlock, field: string) => {
  try { return xmlBlock[0].children.filter(el => el.name == field); }
  catch (e) { return xmlBlock.children.filter(el => el.name == field); }
}
export const getXMLField = (xmlBlock, field: string) => {
  if (field === 'src' || field === 'alt') {
    const regex = new RegExp(`<${field}>(.*?)<\/${field}>`);
    const match = xmlBlock.match(regex);
    if (match) {
      const data = match[1];
      return data;
    } else {
      return ''
    }
  }
  try {
    const fieldXML = xmlBlock[0].children.find(el => el.name === field);
    return fieldXML ? getXMLFieldContent(fieldXML) : null;
  } catch (er) {
    const fieldXML = xmlBlock && xmlBlock.children ? (xmlBlock.children.find(el => el.name === field)) : null;
    if (!fieldXML) return null;
    return getXMLFieldContent(fieldXML);
  }
};

const getXMLFieldContent = (fieldXML) => {
  if (!fieldXML || !fieldXML.children) return '';

  return fieldXML.children.map(child => {
    if (child.type === 'text') {
      return child.data;
    } else if (child.type === 'tag') {
      return `<${child.name}>${getXMLFieldContent(child)}</${child.name}>`;
    }
    return '';
  }).join('');
};


/**
 * Otput always dd.mm.yyyy
 */
export const formatDate = (date, inputFormat?: string, outputSeparator?: string) => {
  const DATE_SEPARATOR = outputSeparator ?? '.';
  if (inputFormat) {
    const dayIndex = inputFormat.indexOf('DD');
    const monthIndex = inputFormat.indexOf('MM');
    const yearIndex = inputFormat.indexOf('YYYY');
    return `${date.substring(dayIndex, dayIndex + 2)}${DATE_SEPARATOR}${date.substring(monthIndex, monthIndex + 2)}${DATE_SEPARATOR}${date.substring(yearIndex, yearIndex + 4)}`;
  } else {
    const d = new Date(date);
    return `${d.getDate()}${DATE_SEPARATOR}${d.getMonth() + 1}${DATE_SEPARATOR}${d.getFullYear()}`;
  }
};


export const elementIsInViewport = (element) => {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}


export const setElementWidthByCardsContainer = (el: HTMLElement, mauto?: boolean) => {
  if (window.innerWidth < 1024) {
    el.style.marginLeft = mauto ? 'auto' : '0px';
    return;
  };
  setTimeout(() => {
    const carousel = document.querySelector('#purchase-options .carousel-container');
    if (carousel) {
      const computedStyle = getComputedStyle(carousel);
      el.style.width = (carousel.clientWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight))) + 'px'
      el.classList.remove('mx-auto');
      el.style.marginLeft = computedStyle.paddingLeft
    } else {
      /* const fitContents = document.querySelector('#purchase-options .w-fit.contents div') as HTMLElement;
       fitContents && (pb.style.width = fitContents.offsetWidth+'px')*/
      const cards = document.querySelectorAll('#purchase-options .solepro-option-card');
      try {
        el.style.width = (cards[cards.length - 1].getBoundingClientRect().right - cards[0].getBoundingClientRect().left) + 'px';
      } catch (e) {
        /** Security fallback */
        el.style.width = '768px';

      }
    }
  }, 200)
}


export const manageScroll = evt => {
  evt.preventDefault();
  try {
    const id = evt.currentTarget.href.split('#')[1]
    const rect = document.getElementById(id).getBoundingClientRect();
    const y = rect.top + window.scrollY - 140;
    window.scrollTo(0, y)
    
  } catch (e) {
    console.error('manageScroll erore', e)
  }
}